const AssetsLoadProgress = {
  created() {
    let perfData = window.performance.timing;
    let estimatedTime = Math.abs(perfData.loadEventEnd - perfData.navigationStart);
    this.loadTime = parseInt((estimatedTime / 1000) % 60) * 100;
    this.doProgress();
  },
  methods: {
    doProgress() {
      let step = this.loadTime / 100;
      this.interval = setInterval(() => {
        this.assetsLoadingPercent++
      }, step);
    }
  },
  computed: {
    loaded() {
      return this.assetsLoadingPercent + '%'
    }
  },
  watch: {
    assetsLoadingPercent(val) {
      if (val >= 100) {
        clearInterval(this.interval)
      }
    }
  },
  data() {
    return {
      assetsLoadingPercent: 0,
      loadTime: 0,
      interval: null
    }
  }
}

export default AssetsLoadProgress;
